import * as React from "react"

const Wrapper = ({ children }) => {
  return <div className="max-w-screen-lg mx-auto px-3 md:px-8">{children}</div>
}

export default Wrapper
